import PropTypes from "prop-types";
import { Form, Input } from "semantic-ui-react";
import GooglePlaceAutoCompleteInput from "./GooglePlaceAutocompleteInput";

const ICAddressForm = ({
  currentFieldValue,
  updateField,
  invalidFieldValue,
  canValidateField,
  disabled,
}) => (
  <>
    <Form.Field
      width={12}
      error={invalidFieldValue && invalidFieldValue("street")}
      onBlur={() => canValidateField("street")}
      disabled={disabled}
    >
      <label htmlFor="street">Address</label>
      <GooglePlaceAutoCompleteInput
        name="street"
        value={currentFieldValue("street")}
        onChange={(value) => updateField("street", value)}
        withOverride
        stateShort
      />
    </Form.Field>
    <Form.Group>
      <Form.Field
        width={6}
        error={invalidFieldValue && invalidFieldValue("street2")}
        onBlur={() => canValidateField("street2")}
        disabled={disabled}
      >
        <Form.Input
          label="Apt/Suite/Unit"
          name="street2"
          value={currentFieldValue("street2")}
          onChange={(e) => updateField("street2", e.target.value)}
          placeholder="Apt #"
        />
      </Form.Field>
      <Form.Input
        name="city"
        label="City"
        width={6}
        value={currentFieldValue("city")}
        onChange={(e) => updateField("city", e.target.value)}
        placeholder="City"
        disabled={disabled}
      />
    </Form.Group>
    <Form.Group>
      <Form.Field
        disabled={disabled}
        label="State"
        name="state"
        width={6}
        control={Input}
        fluid
        placeholder="State/Province"
        value={currentFieldValue("state")}
        onChange={(e) => updateField("state", e.target.value)}
      />
      <Form.Field
        width={6}
        error={invalidFieldValue && invalidFieldValue("zip")}
        onBlur={() => canValidateField("zip")}
        disabled={disabled}
      >
        <Form.Input
          label="Postal code"
          placeholder="Postal code"
          name="zip"
          value={currentFieldValue("zip")}
          onChange={(e) => updateField("zip", e.target.value)}
        />
      </Form.Field>
    </Form.Group>
    <Form.Field
      width={12}
      error={invalidFieldValue && invalidFieldValue("country")}
      onBlur={() => canValidateField("country")}
      disabled={disabled}
    >
      <Form.Input
        label="Country"
        placeholder="Country"
        name="country"
        value={currentFieldValue("country")}
        onChange={(e) => updateField("country", e.target.value)}
      />
    </Form.Field>
  </>
);

ICAddressForm.propTypes = {
  disabled: PropTypes.bool.isRequired,
  currentFieldValue: PropTypes.func.isRequired,
  updateField: PropTypes.func.isRequired,
  invalidFieldValue: PropTypes.func.isRequired,
  canValidateField: PropTypes.func.isRequired,
};

export default ICAddressForm;
